import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography, useTheme} from "@mui/material";
import { SyntheticEvent, useState } from "react";
import { Close, DescriptionRounded, ReplayRounded, SearchRounded } from "@mui/icons-material";
import { useQuery } from "@tanstack/react-query";
import { getExpiredFromRaCode } from "../../services/http.services";
import CustomLoader from "../../../../util/component/CustomLoader";
import { EXPIRED_PRACTICES_QUERY_KEY } from "../../config";

const NewPracticeButton = () => {
    const {t} = useTranslation("expiredManagement");
    const theme = useTheme();

    const [raSearchCode, setRaSearchCode] = useState<string>('');
    const [raResult, setRaResult] = useState<string>('');
    const [errorResult, setErrorResult] = useState<string>('');
    const [openSearcRaDialog, setOpenSearchRaDialog] = useState(false);

    const getExpiredFromRaCodeQuery = useQuery(
        [EXPIRED_PRACTICES_QUERY_KEY.GET_EXPIRED_FROM_RA_CODE],
        {
            enabled: false,
            queryFn: () => {
                return getExpiredFromRaCode(raSearchCode);
            },
            onSuccess(response) {

                if(!!response?.data?.raCode) {
                    setErrorResult('');
                    setRaResult(response.data.raCode);
                }
            },
            onError(error: any) {

                setErrorResult(t(`common.message.error.getExpiredFromRaCode.${error?.response?.status}`, t('common.message.error.tryLater')),);
                
            }
    });

    const handleReset = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        setRaSearchCode('');
        
        if(!!errorResult) setErrorResult('');
    }

    const handleOnClose = (event: React.SyntheticEvent) => {
        event.stopPropagation();

        setOpenSearchRaDialog(false);
        setRaSearchCode('');
        setRaResult('');
        setErrorResult('');
    };

    const handleSubmit = (event: SyntheticEvent) => {
        event.stopPropagation();

        if(!!raSearchCode)
            getExpiredFromRaCodeQuery.refetch();
    }

    const handleDetail = (event: SyntheticEvent) => {
        event.stopPropagation();

        setRaSearchCode('');
        setRaResult('');
        setErrorResult('');
        
        window.open(`/expired-management/insert-practice/${raResult}`, "_blank");
    }

    return(
        <>

            <Button onClick={() => setOpenSearchRaDialog(true)}>
                {t('searchExpired.button.insertExpired')}
            </Button>
            
            <Dialog open={openSearcRaDialog} onClose={handleOnClose} fullWidth>
                <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>{t('newExpired.dialog.title')}</Typography>

                    <IconButton onClick={handleOnClose} sx={{ml: theme.spacing(4), mr: "0px"}}>
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={theme.spacing(2)}>
                        <Grid item container xs={12}>
                            <Grid item xs={12} sm={8}>
                                <TextField
                                    label={t('searchExpired.form.raCode')}
                                    value={raSearchCode}
                                    onChange={(event) => {
                                        setRaSearchCode(event.currentTarget.value || '');
                                    }}
                                    fullWidth
                                    autoFocus  
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} sx={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                <Button 
                                    variant={'text'}
                                    color={"accent"}
                                    startIcon={<ReplayRounded />}
                                    onClick={handleReset}
                                    sx={{mx: theme.spacing(0.5)}}>
                                    {t('common.button.reset')}
                                </Button>

                                <Button 
                                    color={"accent"}
                                    size={"icon"}
                                    onClick={handleSubmit}
                                    sx={{mx: theme.spacing(0.5)}}
                                >
                                    <SearchRounded />
                                </Button>
                            </Grid>
                        </Grid>
                        {!!errorResult ? 
                            <Grid item xs={12} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                <Typography>{ errorResult }</Typography>
                            </Grid>
                            : 
                            (!!raResult ?
                                <Grid item container xs={12} display={"flex"} alignItems={"center"} >
                                    <Grid item xs={11}>
                                        <Typography>{raResult}</Typography>
                                    </Grid>
                                    <Grid item xs={1} display={"flex"} justifyContent={"flex-end"}>
                                        <IconButton
                                            title={t('common.button.detail')}
                                            color="accent"
                                            onClick={handleDetail}
                                        > 
                                            <DescriptionRounded />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                : 
                                <>
                                    <Grid item xs={12} />
                                    <Grid item xs={12} />
                                    <Grid item xs={12} />
                                </>
                            )
                        }
                    </Grid>
                </DialogContent>
            </Dialog>
            <CustomLoader loading={getExpiredFromRaCodeQuery.isFetching} />
        </>
    )

}

export default NewPracticeButton;